import { useState, useRef, useEffect } from "react";
import { useTheme } from "styled-components";
const useDropdownBehavior = () => {
  var _a;
  const [dropdown, setDropdown] = useState(false);
  const ref = useRef(null);
  const timeoutRef = useRef(null);
  const theme = useTheme();
  const breakpoints = (_a = theme.constellation) == null ? void 0 : _a.breakpoints;
  const onMouseEnter = () => {
    if (breakpoints && window.innerWidth >= breakpoints.xl) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      setDropdown(true);
    }
  };
  const onMouseLeave = () => {
    if (breakpoints && window.innerWidth >= breakpoints.xl) {
      timeoutRef.current = setTimeout(() => {
        setDropdown(false);
        timeoutRef.current = null;
      }, 50);
    }
  };
  useEffect(() => {
    if (!breakpoints || window.innerWidth < breakpoints.xl) {
      return;
    }
    const handler = (event) => {
      if (dropdown && ref.current && !ref.current.contains(event.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [dropdown, breakpoints]);
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  return {
    dropdown,
    setDropdown,
    ref,
    onMouseEnter,
    onMouseLeave
  };
};
export {
  useDropdownBehavior
};
